import { QueryClient } from "@tanstack/react-query";

/**
 * Defaults from contract §7.6.
 *
 * `throwOnError: false` on purpose: every list and detail screen renders
 * `<ErrorState />` itself, so an API failure never blows past a component into
 * the route error boundary.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        retry: 1,
        refetchOnWindowFocus: false,
        throwOnError: false,
      },
      mutations: {
        retry: 0,
        throwOnError: false,
      },
    },
  });
}

export const queryClient = createQueryClient();
